import React from 'react';
import CheckboxTreeOriginal from 'react-checkbox-tree';
import PropTypes from 'prop-types';
import './CheckboxTree.scss';

const DEMO_NODES = [
  {
    value: 'mars',
    label: 'Mars',
    children: [
      { value: 'phobos', label: 'Phobos' },
      { value: 'deimos', label: 'Deimos' }
    ]
  },
  {
    value: 'mars2',
    label: 'Mars2',
    children: [
      { value: 'phobos2', label: 'Phobos' },
      { value: 'deimos2', label: 'Deimos' }
    ]
  }
];

const CheckboxTree = ({ nodes = DEMO_NODES, ...rest }) => {
  return (
    <div>
      <CheckboxTreeOriginal nodes={nodes} {...rest} />
    </div>
  );
};

CheckboxTree.propTypes = {
  nodes: PropTypes.array,
  onCheck: PropTypes.func,
  onExpand: PropTypes.func
};

export default CheckboxTree;
